<template>
  <div class="head-wrapper">
    <header
      class="max-page"
      :class="flag ? 'black' : ''"
    >
      <!-- 图标 -->
      <router-link
        to="/"
        class="logo"
      ><img
          src="@/assets/imgs/logo.png"
          alt="暴风影音"
          srcset=""
        ></router-link>

      <!-- 导航部分 -->
      <div class="nav-wrap">
        <ul>
          <li
            v-for="(item, index) in navList"
            :key="index + item.nav_id"
          >
            <router-link
              v-if="item.nav_id != '203'"
              :to="{path:`/index/${item.nav_id}`}"
            >
              {{item.name}}
            </router-link>
            <router-link
              v-if="item.nav_id == '203'"
              to="/"
              exact
            >
              {{item.name}}
            </router-link>
          </li>
        </ul>
      </div>

      <ResidentAnnouncement />

      <!-- 用户部分 -->
      <div class="control-wrap">
        <!-- 搜索 -->
        <div class="search-wrap">
          <input type="text" v-model="searchValue" placeholder="请输入" class="input-search" @click="inputClick" @blur="outInput" @input="handleQuery" @keyup.enter="searchClick" />
          <button type="primary" class="button-search" @click="searchClick">搜一下</button>
        </div>
        <template v-if="showsearch" class="showsearchid">
          <div class="realtime-search" v-if="realtimeShow">
            <div class="serach-history" v-if="historyShow">
              <div class="history-top">
                <span class="histories">搜索历史</span>
                <span class="clearhistory" @click="clearHistory">清除记录</span>
              </div>
              <div class="history-bottom">
                <ul>
                  <li v-for="(item, index) in historyList" :key="index" @click="historyClick(item)">{{ item }}</li>
                </ul>
              </div>
            </div>
            <div class="realtime-hotsearch">
              <span class="hotsearch-title">实时热搜</span>
              <ul>
                <li v-for="(item, index) in hotwordList" :key="item.mid+index" @click="hotsearchClick(item.word)"><span class="hot-number">{{ index+1 }}</span><span class="hot-name">{{ item.word }}</span></li>
              </ul>
            </div>
          </div>
          <div class="cuewords" v-if="cuewordShow">
            <ul>
              <li v-for="(item, index) in cuewordList" :key="index" @click="cuewordClick(item.key)">{{ item.key }}</li>
            </ul>
          </div>
        </template>
        <!-- 会员状态 -->
        <Tooltip
          placement="bottom"
          class="vip-tip"
        >
          <div
            class="head-vip-icon"
            @click="openVip"
          ></div>
          <div
            slot="content"
            class="vip-icon-content"
          >
            <span
              v-if="!isLogin"
              class="btn"
              @click="login"
            >立即登录</span>
            <h3
              class="phone-number"
              v-if="isLogin"
            >{{phone_number}}</h3>
            <div class="content">
              <div class="title">
                <span class="hr-left"></span>
                <span class="text">VIP尊享特权</span>
                <span class="hr-right"></span>
              </div>
              <div class="vip-sign">
                <ul>
                  <li><span class="mian-icon"></span>付费大片</li>
                  <li><span class="hd-icon"></span>更高清晰度</li>
                  <li><span class="qiantie-icon"></span>免广告特权</li>
                  <li><span class="vip-crown"></span>尊贵身份</li>
                </ul>
              </div>
              <div class="open-bg-vip">
                <span
                  class="btn"
                  @click="openVip"
                >开通暴风影音VIP</span>
              </div>
            </div>
          </div>
        </Tooltip>
        <!-- 下载 -->
        <router-link
          class="icons download"
          target="_blank"
          :to="{path:'/download'}"
        >
        </router-link>
        <!-- 反馈 -->
        <a
          class="icons feedback"
          target="_blank"
          href='http://bf.fun.tv/user/feedback?ver=5.88.8888.1111'
        ></a>
        <!-- 登录 -->
        <Tooltip
          placement="bottom-end"
          class="login-tip"
        >
          <div
            :class="['avatar icons', {'is-vip':isVip}]"
            @click="goProfile"
          >
            <img :src="loginUrl">
          </div>
          <div
            slot="content"
            class="login-tip-content"
          >
            <div class="tip-con-first">
              <img :src="baofengBg">
              <a
                v-if="isLogin"
                href="javascript:;"
                @click="logout"
              >退出登录</a>
            </div>
            <div class="tip-con-second">
              <!-- 未登录 -->
              <div
                class="login-not"
                v-if="!isLogin"
              >
                <span class="desc">各段记录同步，即使追精彩</span>
                <span
                  class="btn"
                  @click="login"
                >登录</span>
              </div>

              <!-- 已登录 会员 -->
              <div
                class="login-done-vip"
                v-if="isLogin && isVip"
              >
                <p class="phoneNumber">{{nick_name}}</p>
                <div class="tip-desc">
                  <span>会员有效期至：&nbsp;{{ vip_enddate }}</span>
                  <span
                    class="btn"
                    @click="openVip"
                  >续费</span>
                </div>
              </div>

              <!-- 已登录 非会员 -->
              <div
                class="login-done-novip"
                v-if="isLogin && !isVip"
              >
                <div class="no-vip-title">
                  <p class="phoneNumber">{{nick_name}}</p>
                  <span
                    class="btn"
                    @click="openVip"
                  >开通</span>
                </div>
                <div class="no-vip-desc">
                  <span>专属会员权益:</span>
                  <ul>
                    <li><span class="type-radio"></span>大片免费看</li>
                    <li><span class="type-radio"></span>免广告特权</li>
                    <li><span class="type-radio"></span>更高清晰度</li>
                    <li><span class="type-radio"></span>VIP标识</li>
                  </ul>
                </div>

              </div>
            </div>
          </div>
        </Tooltip>

        <!-- 登录框组件 -->
        <Login
          :is-show="showLogin"
          @hideModal="changeStauts"
          @updateLoginStatus="syncLoginStatus"
          ref="loginCom"
        />

        <!-- 会员购买组件 -->
        <BuyVIp
          :show-vip="showVip"
          @hideVipModal="hideVipModal"
          @loginModal="openLogin"
        />
      </div>
    </header>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import Login from './Login'
import BuyVIp from './buyVip'
import ResidentAnnouncement from '@/components/ResidentAnnouncement'
import apis from '@/assets/js/api'
import cookie from '@/assets/js/cookie'
import UserImg from '@/assets/imgs/user.png'
import LoginIcon from '@/assets/imgs/baofeng_bg.png'
import VipIcon from '@/assets/imgs/baofeng-icon-vip.png'
const { mapActions, mapState, mapMutations } = createNamespacedHelpers('common')

export default {
  components: {
    Login,
    BuyVIp,
    ResidentAnnouncement
  },
  data () {
    return {
      nick_name: '', // 会员名称
      phone_number: '',
      vip_enddate: '', // 会员截止日期
      userData: '',
      isLogin: false,
      showVip: false,
      isVip: false,
      loginUrl: UserImg,
      baofengBg: LoginIcon,
      user_key: 'bf_login_user',
      flag: false,
      showLogin: false, // 展示登录框
      cuewordShow: false, // 提示词框是否显示
      historyShow: false, // 搜索历史是否展示
      searchValue: '', // 搜索框内容
      realtimeShow: false, // 实时搜索框是否显示
      clearBtn: false, // 是否点击了清除历史记录按钮
      hotwordList: [], // 热搜
      historyList: [], // 搜索的历史记录
      cuewordList: [], // 提示词
      showsearch: false
    }
  },
  computed: {
    ...mapState({
      navList: state => state.navList,
      showBuyVip: state => state.showBuyVip
    })
  },
  watch: {
    // $route (val) {
    //   console.log('检测到的路由', val)
    // },
    showBuyVip (newVal) {
      // console.log('检测到变化购买会员=====>', newVal)
      this.showVip = newVal
    }
  },
  created () {
    document.addEventListener('click', e => {
      // console.log('haaaaaaaaaaaaaaaaaaaa', $(e.target)[0].className)
      if ($(e.target)[0].className !== 'input-search') {
        this.showsearch = false
      }
      // let list = document.getElementById("showsearchid")
      // if (list.contains(e.target)) {
      //   console.log("在内")
      // } else {
      //   this.showsearch = false
      // }
    })
  },
  mounted () {
    this.get_channel()
    window.addEventListener('scroll', this.handleScroll)
    // 同步登录状态
    this.syncLoginStatus()

    // 根据url 展示哪个弹层
    this.whichShowMoal()
  },
  methods: {
    ...mapActions(['get_channel', 'handleLogout', 'hotwordlist', 'suggestionlist', 'searchmedia']),
    ...mapMutations(['showVipModal', 'syncLoginData']),
    // 同步登录状态
    syncLoginStatus () {
      const getLogin = cookie.get(this.user_key)
      if (!getLogin) { // 代表用户没有登录 或者异常
        this.logout()
      }
      try {
        const info = JSON.parse(getLogin)
        this.syncLoginData({ loginStatus: true })
        this.userData = info
        // 是否是vip 是的话 图片取会员图片否则默认 >0 代表会员
        if (info['uservipinfo'] && info['uservipinfo']['vip']['vip_class'] > 0) {
          this.baofengBg = VipIcon
          this.isVip = true
        }
        if (info['userbaseinfo']) {
          this.loginUrl = info['userbaseinfo']['user_icon']['orig']
        }
        // 是否登录
        if (this.userData.user_id) {
          this.isLogin = true
        }
        const { userbaseinfo, uservipinfo } = this.userData
        this.nick_name = userbaseinfo.nick_name
        this.vip_enddate = uservipinfo.vip.endtm.split(' ')[0]
        const numLeng = userbaseinfo.phone.length
        this.phone_number = userbaseinfo.phone.substring(0, 3) + '***' + userbaseinfo.phone.substring(numLeng - 3)
      } catch (e) {
        this.logout()
      }
    },
    // 退出登录
    logout () {
      const getUserCookie = cookie.get(this.user_key)
      if (!getUserCookie) return
      let userInfo = JSON.parse(getUserCookie)
      let param = {
        user_id: userInfo.user_id,
        token: userInfo.token
      }
      param = Object.assign({}, param, apis.poseidonCommonParamsNew)
      this.handleLogout(param).then(() => {
        this.syncLoginData({ loginStatus: false })
        cookie.remove(this.user_key)
        // 更新用户状态为未登录状态
        this.isLogin = false
        this.baofengBg = LoginIcon
        this.loginUrl = UserImg
        this.userData = '' // 清空存储的用户信息
        this.isVip = false
        this.phone_number = ''
        this.nick_name = ''
        this.vip_enddate = ''
        if (this.$route.path === '/profile') {
          this.$router.replace('/')
        }
      })
    },
    // 开通vip
    openVip () {
      this.showVip = true
    },

    whichShowMoal () {
      const openModalMsg = this.$route.query
      const getLogin = cookie.get(this.user_key)
      setTimeout(() => {
        if (openModalMsg.open && openModalMsg.open === 'login') {
          if (getLogin) return
          this.showLogin = true
          return
        }
        if (openModalMsg.open && openModalMsg.open === 'buyVip') {
          this.showVip = true
        }
      }, 1000)
    },

    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      scrollTop > 500 ? this.flag = true : this.flag = false
    },
    login () {
      if (!this.userData.user_id) {
        this.showLogin = true
      }
    },
    changeStauts () {
      this.showLogin = false
    },

    // 打开登录框
    openLogin (type) {
      this.showLogin = true
      this.showVip = false
      this.showVipModal({ open: false })

      if (type && type === 'toggleUser') { // 切换用户 首先要退出登录
        this.logout()
      }
    },
    // 隐藏vip购买框 (坑: 注意要同时更新 vuex 状态)
    hideVipModal (type) {
      this.showVip = false
      this.showVipModal({ open: false })
      // 会员购买成功 重新获取用户基本信息
      if (type && type === 'login_state_change') {
        this.$refs.loginCom && this.$refs.loginCom.readyLoginUpdate('bySuccess')
      }
    },

    // 跳转到个人中心
    goProfile () {
      if (this.isLogin && this.$route.path !== '/profile') {
        this.$router.push({
          name: 'Profile',
          params: {
            hide: 'footer'
          }
        })
      }
    },
    // 点击搜索显示热搜榜
    inputClick () {
      this.$set(this, 'showsearch', !this.showsearch)
      // 获取搜索的历史记录
      if (this.historyList.length > 0) {
        this.historyShow = true
      } else {
        this.historyShow = false
      }
      // 获取搜索热词
      const params = {
        cl: this.$store.state.common.cl
      }
      this.hotwordlist(params).then(res => {
        if (res.retcode === '200' && res.data && res.data.length > 0) {
          this.hotwordList = res.data.slice(0, 10)
          console.log('热搜：', this.hotwordList)
        } else {
          this.hotwordList = []
        }
      }).catch(err => {
        console.log(err)
      })
      this.realtimeShow = true
      this.cuewordShow = false
    },
    // input失去焦点事件
    outInput () {},
    // 实时搜索
    clearTimer () {
      if (this.timer) {
        clearTimeout(this.timer)
      }
    },
    handleQuery (event) {
      this.clearTimer()
      this.timer = setTimeout(() => {
        const params = {
          q: this.searchValue
          // cp: r4k0se
          // cl: newweb_baofeng
        }
        this.suggestionlist(params).then(res => {
          if (res.retcode === '200' && res.keys && res.keys.length > 0) {
            this.cuewordList = res.keys
            this.cuewordShow = true
            this.realtimeShow = false
          } else {
            this.cuewordList = []
            this.cuewordShow = false
            this.realtimeShow = true
          }
        }).catch(error => {
          console.log('获取关键词接口失败：', error)
        })
      }, 500)
    },
    // 点击搜索
    searchClick () {
      console.log('路由地址：', this.$route.path)
      // 获取搜索结果
      this.realtimeShow = false
      this.cuewordShow = false
      const params = {
        q: this.searchValue,
        cp: 'fr4k0se',
        vip: 1
        // cp: ''
      }
      sessionStorage.setItem('searchword', this.searchValue)
      this.searchmedia(params).then(res => {
        if (res.retcode === '200') {
          if (this.$route.path !== '/searchresult') {
            this.$router.push({
              name: 'searchResult'
            })
          }
        }
      }).catch(error => {
        console.log(error)
      })
      // 点击搜索，添加一条历史记录
      this.addhistory()
    },
    // 添加历史记录
    addhistory () {
      if (localStorage.getItem('historylist') !== null && localStorage.getItem('historylist').length > 0) {
        var historyArray = JSON.parse(localStorage.getItem('historylist'))
        if (this.searchValue !== '' && !historyArray.includes(this.searchValue)) {
          if (historyArray.length == 10) {
            this.historyList.pop()
            this.historyList.unshift(this.searchValue)
          } else {
            this.historyList.unshift(this.searchValue)
          }
          localStorage.setItem('historylist', JSON.stringify(this.historyList))
        }
      } else {
        this.historyList.unshift(this.searchValue)
        localStorage.setItem('historylist', JSON.stringify(this.historyList))
      }
    },
    // 清除历史记录
    clearHistory () {
      localStorage.removeItem('historylist')
      this.historyList = []
      this.historyShow = false
    },
    // 点击历史记录跳转
    historyClick (value) {
      this.searchValue = value
      this.searchClick()
    },
    // 点击热搜跳转
    hotsearchClick (value) {
      this.searchValue = value
      this.searchClick()
    },
    // 点击提示词跳转
    cuewordClick (value) {
      this.searchValue = value
      this.searchClick()
    }
  }
}
</script>
<style lang="less" scoped>
.head-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100%;
  height: 64px;
  background: linear-gradient(180deg, #16161c 0%, rgba(22, 22, 28, 0) 100%);
  header {
    height: 100%;
    .nav-wrap,
    .control-wrap {
      display: inline-block;
      .search-wrap {
        display: inline-block;
      }
    }
    .logo {
      display: inline-block;
      img {
        margin-top: 12px;
        width: 150px;
        height: 40px;
      }
    }
    .nav-wrap {
      height: 100%;
      vertical-align: top;
      margin-left: 40px;
      max-width: 700px;
      overflow: hidden;
      white-space: nowrap;
      ul {
        li {
          display: inline-block;
          font-size: 18px;
          color: #fff;
          line-height: 64px;
          margin: 0 12px;
          cursor: pointer;
          &:hover {
            color: #0184ff;
          }
          .router-link-active {
            color: #0184ff;
          }
        }
      }
    }
    .control-wrap {
      float: right;
      margin-top: 18px;
      .icons {
        display: inline-block;
        width: 28px;
        height: 28px;
        margin: 0 9px;
      }
      .download {
        background: url('~@/assets/imgs/down.png') no-repeat;
        background-size: contain;
        &:hover {
          background: url('~@/assets/imgs/down-hover.png') no-repeat;
        }
      }
      .feedback {
        background: url('~@/assets/imgs/feedback.png') no-repeat;
        background-size: contain;
        &:hover {
          background: url('~@/assets/imgs/feedback-hover.png') no-repeat;
        }
      }
      .avatar {
        cursor: pointer;
        &:hover {
          background: url('~@/assets/imgs/user-hover.png') no-repeat;
          background-size: contain;
        }
        img {
          width: 100%;
        }
      }
      .head-vip-icon {
        cursor: pointer;
        margin: 0 9px;
        img {
          width: 100%;
        }
      }
      // .is-vip {
      //   background: url('~@/assets/imgs/vip-bg.png') no-repeat;
      //   width: 34px;
      //   height: 46px;
      //   background-size: contain;
      //   border-radius: 0;
      //   img {
      //     width: 30px;
      //     height: 30px;
      //     margin-top: 14px;
      //     margin-left: 2px;
      //   }
      // }
      .search-wrap {
        float: left;
        position: relative;
        margin-right: 30px;
        .input-search {
          width: 350px;
          height: 30px;
          color: #ffffff;
          font-size: 14px;
          padding: 2px 8px;
          font-family:'SourceHanSansCN-Normal, SourceHanSansCN';
          border: none;
          outline: none;
          background: #FFFFFF;
          border-radius: 31px;
          background: rgba(255, 255, 255, 0.1);
        }
        .input-search:focus {
          background: rgba(255, 255, 255, 0.2);
          // border: 1px solid #02AAFF;
        }
        .button-search {
          position: absolute;
          right: 0px;
          font-size: 14px;
          font-family: 'SourceHanSansCN-Medium, SourceHanSansCN';
          font-weight: 500;
          color: #FFFFFF;
          background: linear-gradient(90deg, #02AAFF 0%, #0180FF 100%);
          border-radius: 20px;
          padding: 8px 15px;
          border:0;/*去掉未选中边框*/
          outline:none;/*去掉选中边框*/
          cursor: pointer;
        }
      }
      .realtime-search {
        width: 350px;
        // height: 490px;
        overflow-y: auto;
        position: absolute;
        top: 50px;
        background: linear-gradient(180deg, #31313C 0%, #16161C 100%);
        border-radius: 4px;
        .serach-history {
          margin: 15px 14px;
          .history-top {
            span {
              font-family: 'SourceHanSansCN-Normal, SourceHanSansCN';
              font-weight: 400;
              color: #FFFFFF;
              opacity: 0.5;
            }
            .histories {
              font-size: 16px;
            }
            .clearhistory {
              font-size: 14px;
              cursor: pointer;
              float: right;
              margin-top: 2px;
            }
          }
          .history-bottom {
            ul {
              margin: 10px 0;
              li {
                display: inline-block;
                font-size: 14px;
                font-family: 'SourceHanSansCN-Normal, SourceHanSansCN';
                font-weight: 400;
                color: #FFFFFF;
                padding: 5px 8px;
                margin-top: 8px;
                margin-left: 8px;
                opacity: 0.6;
                border: 1px solid #FFFFFF;
                cursor: pointer;
              }
              // li:nth-child(1) {
              //   margin-left: 0;
              // }
            }
          }
        }
        .realtime-hotsearch {
          margin: 15px 14px;
          .hotsearch-title {
            font-size: 16px;
            font-family: 'SourceHanSansCN-Normal, SourceHanSansCN';
            font-weight: 400;
            color: #FFFFFF;
            opacity: 0.5;
          }
          ul {
            margin-top: 20px;
            li {
              padding: 5px 0;
              font-size: 14px;
              font-family: 'SourceHanSansCN-Normal, SourceHanSansCN';
              font-weight: 400;
              color: #FFFFFF;
              cursor: pointer;
              .hot-number {
                display: inline-block;
                width: 20px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                color: #FFFFFF;
                background:rgba(255, 255, 255, 0.2);
              }
              .hot-name {
                padding-left: 8px;
                color: #FFFFFF;
                opacity: 0.8;
              }
            }
            li:nth-child(1), li:nth-child(2), li:nth-child(3) {
              .hot-number {
                background: #0184FF;
              }
            }
            li:hover{
              background:rgba(255, 255, 255, 0.1) ;
            }
          }
        }
      }
      .cuewords {
        width: 350px;
        position: absolute;
        top: 50px;
        background: linear-gradient(180deg, #31313C 0%, #16161C 100%);
        border-radius: 4px;
        ul {
          margin: 10px 0;
          li {
            font-size: 14px;
            font-family: 'SourceHanSansCN-Normal, SourceHanSansCN';
            font-weight: 400;
            color: #FFFFFF;
            padding: 10px 15px;
            opacity: 0.7;
            cursor: pointer;
          }
          li:hover{
            background:rgba(255, 255, 255, 0.1) ;
          }
        }
      }
    }
  }
  .black {
    background: rgba(22, 22, 28, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonHead.vue